<ng-container *ngIf="(currentUser.isLoggedIn$ | async) || (breakpoints.isMobile$ | async); else authButtons">
    <div class="menu-trigger" [matMenuTriggerFor]="menu">
        <img class="avatar" [src]="currentUser.get('avatar')">

        <div class="email">{{currentUser.get('email')}}</div>
        <mat-icon svgIcon="arrow-drop-down" class="dropdown-icon"></mat-icon>

        <button mat-icon-button class="mobile-toggle" aria-label="Show logged in user options">
            <mat-icon svgIcon="person"></mat-icon>
        </button>
    </div>

    <mat-menu #menu="matMenu" [overlapTrigger]="false" class="logged-in-user-widget-menu">
        <logged-in-user-menu></logged-in-user-menu>
    </mat-menu>
</ng-container>

<ng-template #authButtons>
    <a routerLink="/customer" mat-raised-button color="accent" class="login-btn" trans>Customer Login</a>
    <!-- <a *ngIf="!config.get('registration.disable') && !hideRegisterButton" class="register-btn" routerLink="/register"  mat-button trans>Employee Register</a> -->
    <a routerLink="/admin" mat-raised-button color="accent" class="register-btn ms-3" trans>Employee Login</a>
</ng-template>
